import React from 'react'
import { styled } from '@mui/system'
import { Box, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export const TabMainWrapper = styled(Box)(`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding-bottom: 30px;
`)

export const Title = styled(Typography)(`
    font-size: 18px;
    font-weight: 400;
    color: #1a1a1a;
`)

export const WarningBox = styled(Box)(`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: #fef3c7;
    padding: 24px;
    width: 100%;
    box-sizing: border-box;
`)

export const WarningText = styled(Typography)(`
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    color: #b45309;
`)

export default function InsufficientData({header}) {
  return (
    <TabMainWrapper>
      <Title>{header}</Title>
      <WarningBox>
        <ErrorOutlineIcon sx={{ color: '#b45309', fontSize: '20px' }} />
        <WarningText>Insufficient data. Try different selections.</WarningText>
      </WarningBox>
    </TabMainWrapper>
  )
}